import React from 'react';
import autobind from 'autobind-decorator';
import {Button, Col, FormControl, Row} from 'react-bootstrap';

import {BaseComponent} from "../../BaseComponent";
import {SB_ENTER_KEY_CODE} from "../../../Constants";
import {KeyboardUtils} from "../../../Utils";

export class ForgotPasswordForm extends BaseComponent {
    @autobind
    submit() {
        if(this.props.Submit) {
            this.props.Submit();
        }
    }

    @autobind
    updatePassword(event) {
        if(this.props.UpdatePassword) {
            this.props.UpdatePassword(event.target.value);
        }
    }

    @autobind
    updatePassword2(event) {
        if(this.props.UpdatePassword2) {
            this.props.UpdatePassword2(event.target.value);
        }
    }

    render() {
        return [
            <Row key={1} className="top10">
                <Col md={4}>
                    <span>New Password</span>
                </Col>
                <Col md={8}>
                    <FormControl
                        autoComplete="new-password"
                        autoFocus
                        type="password"
                        name="password1"
                        value={this.props.Password}
                        onChange={this.updatePassword}
                        onKeyPress={(x) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, x, () => this.submit())}
                    />
                </Col>
            </Row>,
            <Row key={2} className="top10">
                <Col md={4}>
                    <span>Confirm New Password</span>
                </Col>
                <Col md={8}>
                    <FormControl
                        autoComplete="new-password"
                        type="password"
                        name="password2"
                        value={this.props.Password2}
                        onChange={this.updatePassword2}
                        onKeyPress={(x) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, x, () => this.submit())}
                    />
                </Col>
            </Row>,
            <Row key={3} className="top10">
                <Col md={4} />
                <Col md={8}>
                    <Button onClick={this.submit} variant="primary">Update Password</Button>
                </Col>
            </Row>,
            <Row key={4} className="top10">
                <Col md={4} />
                <Col md={8}>
                    <br />
                </Col>
            </Row>
        ];
    }
}


